module.exports = () => {
  return {
    name: {
      label: '模板名称',
      type: 'label',
      value: '-',
    },
    advertiser: {
      label: '广告主账户',
      type: 'label',
      value: '-',
    },
    advertiser_source: {
      label: '模板来源',
      type: 'label',
      value: '-',
    },
    site_url: {
      label: '落地页url',
      value: '-',
    },
    android_download_link: {
      label: '安卓下载链接',
      type: 'label',
      value: '',
    },
    ios_download_link: {
      label: 'iOS下载链接',
      type: 'label',
      value: '',
    },
    thumbnail: {
      label: '样式预览',
      value: '-',
    },
  };
};
